<template>
  <div class="NavBarApps pt-4">
    <p class="px-4">
      <strong>
        {{ $t(`${$options.name}.title`) }}
      </strong>
    </p>

    <a
      :href="evMapsUrl"
      target="_blank"
      rel="noopener"
      class="d-flex align-items-center px-4"
    >
      <i class="icon fa-fw fal fa-map-location-dot mr-3" />
      <span>EV Maps</span>
    </a>

    <a
      :href="monitoringUrl"
      target="_blank"
      rel="noopener"
      class="d-flex align-items-center px-4"
    >
      <i class="icon fa-fw fal fa-chart-line mr-3" />
      <span>Monitoring</span>
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

// Tenants operating in Belgium, so their users belong on the .be maps site //
// Mirrors the isVlaanderen check in MapLocationSelection.navigateToMaps() //
const BELGIAN_TENANTS = ['vlaanderen', 'mechelen', 'engie']

// Markers of a non-production deployment, as used by isDevelopment elsewhere //
const DEVELOPMENT_MARKERS = ['-dev', '-demo', '-preview', 'localhost', '127.0.0.1']

export default {
  name: 'NavBarApps',
  computed: {
    ...mapGetters('tenant', ['getBaseUrl']),

    /**
     * Dev and production use different Auth0 tenants and API audiences, so a dev
     * user sent to a production app lands on a login wall (or on live data).
     * Both the configured base url and the actual host are checked, so a preview
     * deploy running against a production config still resolves to dev.
     */
    isDevelopment() {
      return [this.getBaseUrl, window.location.hostname]
        .filter(Boolean)
        .some(url => DEVELOPMENT_MARKERS.some(marker => url.includes(marker)))
    },
    isBelgianTenant() {
      return BELGIAN_TENANTS.includes(process.env.VUE_APP_TENANT)
    },
    evMapsUrl() {
      if (this.isBelgianTenant) {
        return this.isDevelopment ? 'https://evmaps-be-dev.netlify.app' : 'https://www.evmaps.be'
      }
      return this.isDevelopment ? 'https://dev.evmaps.nl' : 'https://evmaps.nl'
    },
    monitoringUrl() {
      return this.isDevelopment ? 'https://monitoring-dev.netlify.app' : 'https://monitoring.evtools.nl'
    },
  },
}
</script>

<style scoped lang="scss">
.NavBarApps {
  background: white;
  z-index: 999999;
  opacity: 0.999;
  min-width: 260px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

  p {
    font-size: 1.15rem;
    cursor: auto;
  }

  a {
    font-size: 1.15rem;
    margin-bottom: 1rem;
    color: inherit;

    &:hover {
      text-decoration: none;
      color: #b04300;

      .icon {
        color: #b04300;
      }
    }
  }

  .icon {
    font-size: 1.3rem;
    color: black;
  }
}
</style>
